export default "__VITE_ASSET__CI60P8Ta__"